import React from "react";
import { Typography, Button } from "@mui/material";
import { ReactComponent as ThumbsUp } from "../../../assets/img/thumbsUp.svg";
import Page from "components/ui/Page/Page";
import { FormContainer } from "components/ui/FormField/FormFieldContainer";

const TreatResult = ({ onContinue }) => {
    return (
        <Page
            heading="You’re not alone"
            subHeading="Based on your answers, you qualify for our Treat program, built to support people who have already been diagnosed with a heart condition. You’ll have tools and clinical support to help manage your heart health with confidence, right from home."
        >
            <FormContainer
                heading="What Happens Next?"
                subHeading=" We need your shipping address, so we can send you your KardiaComplete
                    kit."
                sx={{
                    width: "65%",
                }}
            >
                <Button variant="contained" onClick={onContinue}>
                    Continue
                </Button>
            </FormContainer>
        </Page>
    );
};

const PreventResult = ({ onContinue }) => {
    return (
        <Page
            heading="You’re in the right place"
            subHeading="Based on your answers, you qualify for our Prevent program, designed to help catch heart risk early and support healthier habits over time. Starting now gives you more visibility into your heart health and the chance to stay ahead of potential issues."
        >
            <FormContainer
                sx={{
                    width: "65%",
                }}
                heading="What Happens Next?"
                subHeading="We need your shipping address, so we can send you your KardiaComplete
                    kit."
            >
                <Button variant="contained" onClick={onContinue}>
                    Continue
                </Button>
            </FormContainer>
        </Page>
    );
};

const LowRiskResult = ({ onNoThanks }) => {
    return (
        <Page
            heading="Great News! You’re Low Risk"
            subHeading="Based on your answers, you don’t qualify for this program right now. If you’d still like to monitor your heart, you can purchase a Kardia device at a discounted rate."
        >
            <FormContainer
                subHeading={<ThumbsUp />}
                sx={{
                    textAlign: "center",
                    width: "65%",
                }}
            >
                <Button variant="outlined" onClick={onNoThanks}>
                    Get Discount
                </Button>
                <Button variant="outlined" onClick={onNoThanks}>
                    No Thank you
                </Button>
            </FormContainer>
        </Page>
    );
};

const ProgramResult = ({ program, onContinue, onNoThanks }) => {
    console.log("ProgramResult rendered with program:", program);
    return (
        <>
            {program === "TREAT" && <TreatResult onContinue={onContinue} />}
            {program === "PREVENT" && <PreventResult onContinue={onContinue} />}
            {!program && <LowRiskResult onNoThanks={onNoThanks} />}
        </>
    );
};

export default ProgramResult;
